//Event types
export const NOT_STARTED = 1;
export const FIRST_HALF = 2;
export const HALF_TIME = 3;
export const REGULAR_TIME_FINISHED = 4;
export const FULL_TIME = 5;
export const EXTRA_TIME_FIRST_HALF = 6;
export const FINISHED_AFTER_EXTRA_TIME = 7;
export const FULL_TIME_AFTER_PENALTY_SHOOTOUT = 8;
export const PENALTY_SHOOTOUT = 9;
export const POSTPONED = 10;
export const SUSPENDED = 11;
export const CANCELLED = 12;
export const TIME_TBA = 13;
export const WALK_OVER = 14;
export const ABANDONED = 15;
export const DELAYED = 16;
export const AWARDED = 17;
export const INTERRUPTED = 18;
export const AWAITING_UPDATES = 19;
export const DELETED = 20;
export const EXTRA_TIME_BREAK = 21;
export const IN_PLAY_IN_2ND_HALF = 22;
export const IN_PLAY_IN_2ND_EXTRA_TIME = 23;
export const WAITING_FOR_PENALTIES_TO_START = 25;
export const PENDING = 26;

//Score types
export const SCORES_1ST_HALF = 1;
export const SCORES_2ND_HALF = 2;
export const SCORES_ET = 3;
export const SCORES_PENALTY_SHOOTOUT = 5;
export const SCORES_ET_2ND_HALF = 39;
export const SCORES_CURRENT = 1525;

export const EVENT_GOAL = 14;
export const EVENT_OWN_GOAL = 15;
export const EVENT_PENALTY = 16;

export const EVENT_SUBSTITUTION_EVENT = 18;
export const EVENT_YELLOW_CARD_EVENT = 19;
export const EVENT_RED_CARD_EVENT = 20;

export const EVENT_GOALS = 52;
export const EVENT_CORNERS = 34;
export const EVENT_ASSISTS = 79;
export const EVENT_RED_CARD = 83;
export const EVENT_YELLOW_CARD = 84;
export const EVENT_YELLOW_RED_CARD = 85;
export const EVENT_SHOTS_ON_TARGET = 86;
export const EVENT_INJURIES = 87;
export const EVENT_GOALS_CONCEEDED = 88;

export const OVERALL_MATCHES = 129;
export const OVERALL_WINS = 130;
export const OVERALL_DRAWS = 131;
export const OVERALL_LOST = 132;
export const OVERALL_SCORED = 133;
export const OVERALL_CONCEDED = 134;
export const OVERALL_GOAL_DIFFERENCE = 179;

/* //not started
NOT_STARTED,

//in play
FIRST_HALF,
EXTRA_TIME_FIRST_HALF,
IN_PLAY_IN_2ND_HALF,
IN_PLAY_IN_2ND_EXTRA_TIME,
PENALTY_SHOOTOUT

//finished
FULL_TIME,
FINISHED_AFTER_EXTRA_TIME,
FULL_TIME_AFTER_PENALTY_SHOOTOUT

//pause states
HALF_TIME
REGULAR_TIME_FINISHED
EXTRA_TIME_BREAK
WAITING_FOR_PENALTIES_TO_START
SUSPENDED
DELAYED
PENDING


CANCELLED
POSTPONED
WALK_OVER
TIME_TBA
ABANDONED
AWARDED
INTERRUPTED
AWAITING_UPDATES
DELETED */
